import React, { createContext, useContext, useReducer } from "react";

// Context API For Search Functionality 
const SearchContext = createContext();

const initialState = {
    search: ""
};

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_SEARCH":
            return { ...state, search: action.payload };
        default:
            return state;
    }
};

export const SearchProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    
    return (
        <SearchContext.Provider value={{ state, dispatch }}>
            {children}
        </SearchContext.Provider>
    );
}

export const useOrderSearch = () => {
    return useContext(SearchContext);
};
